import React, { useState } from "react";
import { IonCol, IonImg, IonItem, IonRow, IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { withOmaUserService, WithOmaUserServiceProps } from "service";
import "../MainPage.css";
import { Formatter } from "../../../util/Formatter";
import { OmaUser } from "../../../providers/OmaUser/OmaUserActionTypes";

interface OmaUserCellProps extends WithOmaUserServiceProps {
  omaUser: OmaUser;
  onClick: () => void;
}

const OmaUserCell = (props: OmaUserCellProps) => {
  const { t } = useTranslation();

  const customers = props.omaUser?.customers?.map((c) => {
    return <div key={c.id}>{`${c.lastName}, ${c.firstName}`}</div>;
  });

  return (
    <div
      className="OmaUserCell"
      onClick={(e) => {
        e.preventDefault();
        props.onClick();
      }}
    >
      <IonRow style={{ background: "white" }}>
        <IonCol
          size="4"
          className="ion-no-padding ion-padding-top ion-padding-start ion-padding-end"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <IonText className="body2 grey ion-padding-bottom">
            {`${props.omaUser.lastName}, ${props.omaUser.firstName}`}
          </IonText>
        </IonCol>
        <IonCol
          size="4"
          className="ion-no-padding ion-padding-top ion-padding-start ion-padding-end"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <IonText className="body2 grey ion-padding-bottom">
            {customers}
          </IonText>
        </IonCol>
        <IonCol
          size="4"
          className="ion-no-padding ion-padding-top ion-padding-start ion-padding-end"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <IonText className="body2 grey ion-padding-bottom">
            {Formatter.omaUserStatusLocalization(props.omaUser.status, t)}
          </IonText>
        </IonCol>
      </IonRow>
    </div>
  );
};

export default withOmaUserService(OmaUserCell);
